import React from "react";
import { addDomainInImage } from "../core/utils";

const ProductCard = ({ item, getQty, updateQuantity, openQtyModal }) => {
  return (
    <div className="product-card">
      <div className="product-image-container">
        <img
          src={addDomainInImage(item.image)}
          alt={item.name}
          className="product-image"
        />
      </div>

      <div className="product-info">
        <div>
          <h3 className="product-name">
            {/* #{item.id}  */}
            {item.name}
          </h3>
          <p className="product-price">₹ {item.price}</p>
        </div>

        <div className="quantity-controls">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#4CAF50",
              borderRadius: "25px",
              padding: "5px 10px",
            }}
          >
            <button
              onClick={() => updateQuantity(item, -1)}
              className="touchable-button"
              style={{
                width: "40px", // Increased size
                height: "40px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#4CAF50",
                color: "white",
                fontSize: "20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              −
            </button>
            <span
              style={{
                minWidth: "25px",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "bold",
                color: "white",
                margin: "0 8px",
                cursor: "pointer",
              }}
              onClick={() => openQtyModal(item)}
            >
              {getQty(item.id)}
            </span>
            <button
              onClick={() => updateQuantity(item, 1)}
              className="touchable-button"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#4CAF50",
                color: "white",
                fontSize: "20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
